<template>
  <section class="c-select">
    <select
      v-model="computedValue"
      :multiple="multiple">
      <option v-if="placeholder && !selectValue" value="" hidden disabled selected placeholder>{{ placeholder }}</option>
      <slot/>
    </select>
    <button class="action" type="button" @click="dropdown" tabindex="-1"><ab-icon :icon="icon"></ab-icon></button>
  </section>
</template>

<script>
import Choices from 'choices.js';
import 'choices.js/public/assets/styles/choices.min.css';
import AbIcon from '@/components/icon/ab-icon.vue';
export default {
  components: {
    AbIcon
  },
  props: {
    placeholder: String,
    multiple: Boolean,
    value: {
      type: [ Array, String, Number ],
      default: null
    },
    selectText: {
      type: String,
      default: ''
    },
    search: Boolean,
    removeItemButton: Boolean
  },
  data() {
    return {
      icon: 'expand-more',
      selectValue: this.value,
    }
  },
  mounted() {
    this.choices = new Choices(this.$el.querySelector('select'), {
      placeholder: true,
      searchEnabled: this.search,
      placeholderValue: this.placeholder,
      removeItemButton: this.removeItemButton,
      itemSelectText: this.selectText,
      shouldSort: false,
      renderSelectedChoices: 'always'
    });
    this.choices.containerOuter.element.addEventListener('focus', () => {
      this.dropdown();
    });
    ['showDropdown', 'hideDropdown'].map(event => {
      this.choices.passedElement.element.addEventListener(event, (e) => {
        this.changeIcon(e.type);
      });
    });
  },
  methods: {
    dropdown() {
      this.choices.showDropdown();
    },
    changeIcon(event) {
      this.icon = event == 'showDropdown' ? 'expand-less' : 'expand-more';
    }
  },
  computed: {
    computedValue: {
      get() {
        return this.selectValue;
      },
      set(value) {
        this.$emit('input', value);
      }
    },
  },
  watch: {
    value(value) {
      // Need to manually set the selected choices value
      // As it remove the natural behaviour of select element
      if (Array.isArray(value)) {
        this.choices._currentState.items.map(item => this.choices.removeActiveItemsByValue(item.value));
      }
      this.choices.setChoiceByValue(value);
      this.selectValue = value;
    }
  },
}
</script>

<style scoped>
  .c-select {
    position: relative;
    border-radius: 5px;
    height: 2rem;
  }
  .action {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 2.1rem;
    padding: 0;
    text-align: center;
    border-radius: 0 5px 5px 0; 
    border: none;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    color: var(--app-white-color);
    background-color: var(--app-primary-color);
  }
  .action:focus {
    outline: none;
  }
  .ab-icon {
    margin: 0;
  }
</style>
<style>
  /* Global */
  .choices {
    border-radius: 5px;
    height: 100%;
    color: var(--app-dark-grey);
    background-color: var(--app-light-grey);
  }
  .choices[data-type*=select-one] .choices__inner,
  .choices .choices__inner {
    border: none;
    min-height: 100%;
    padding: 0;
    color: var(--app-dark-grey);
    font-family: var(--app-font-regular);
    font-weight: normal;
    letter-spacing: 0.01em;
    background-color: transparent;
  }

  /* Selected  values */
  .choices__inner .choices__list {
    padding-left: 7px ;
    white-space: nowrap;
    text-overflow: clip;
    /* overflow: hidden; */
  }
  .choices__input {
    font-size: inherit;
    margin: 0;
    background-color: transparent;
  }
  .choices__item {
    line-height: 2;
    font-size: 1rem;
  }

  .choices__placeholder,
  .choices__input::placeholder  {
    opacity: 1;
    color: var(--app-dark-grey);
  }
  .choices__list--multiple .choices__item {
    display: inline-block;
    vertical-align: middle;
    border-radius: 20px;
    padding: 0 0.8rem;
    font-size: 0.8rem;
    margin: 0;
    margin-right: 0.3rem;
    background-color: var(--app-primary-color);
    color: var(--app-white-color);
    word-break: break-all;
  }
  .choices__list--multiple .choices__item.is-highlighted {
      background-color: var(--app-primary-color);
      border: 1px solid var(--app-primary-color);
      box-shadow: var(--app-ctn-shadow);
  }
  .choices__list--single {
    padding: 0;
  }
  /* Dropdown */
  .choices__list--dropdown {
    border: none;
    box-shadow: var(--app-ctn-shadow);
    background-color: var(--app-select-dropdown);
    z-index: 2;
  }

  /* Dropdown content */
  .choices__list--dropdown .choices__item
  .choices__group .choices__heading {
    font-weight: bold;
    font-size: 1rem;
    color: inherit;
  }
  .choices__list--dropdown .choices__item {
    padding: 0;
    font-size: 1rem;
    padding-left: 8px;
  }
  .choices__list--dropdown .choices__item--selectable.is-highlighted {
    background-color: var(--app-primary-color);
    color: var(--app-white-color);
  }
  .choices__group~.choices__item {
    padding-left: 2rem;
  }
</style>

